import axios from 'axios';

const apiClient = axios.create({
  baseURL: `${process.env.VUE_APP_AUTH_API_URL}api/v1/icfundauth/`,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default {
  post (url, payload) {
   return apiClient.post(url, payload);
  },
  get (url, payload) {
    return apiClient.get(url, payload);
  },
  put (url, payload) {
    return apiClient.put(url, payload);
  }
};
